export default __webpack_public_path__ + "static/media/bathroom2-afterA-480w.92bbdc1a.png";